import SupplierTypes from '../SupplierTypes';

export default [
  SupplierTypes.PLX_BEST_PRICE,
  SupplierTypes.PLX_QUOTE,
  SupplierTypes.EXCEL_BEST_PRICE,
  SupplierTypes.EXCEL_QUOTE,
  SupplierTypes.AMPEL_BEST_PRICE,
  SupplierTypes.AMPEL_QUOTE,
  SupplierTypes.WHX_BEST_PRICE,
  SupplierTypes.WHX_QUOTE,
  SupplierTypes.MAKER_QUOTE,
];
